module.exports = __webpack_public_path__ + "img/banner_title_en.3201231d.gif";